import React from "react";
import { DiseaseDetail } from "../../../../../domain/disease_knowledge/DiseaseDetail";
import { DiseaseMenuSection, diseaseMenuSectionId } from "./DiseaseMenuSection";

export const DetailContentSuggestingService = React.memo(function DetailContentSuggestingService(props: Props) {
    const {
        disease,
        suggestingServiceRef
    } = props;

    return (
        <>
            <h3 className={"itemName"} id={diseaseMenuSectionId(DiseaseMenuSection.SUGGESTING_SERVICE)} ref={suggestingServiceRef}>
                検討をすすめるサービス
            </h3>
            {disease.suggestingServices.map((suggestingService, index) => (
                <div key={index}>
                    <h4 className={"subItemName"}>{`【${suggestingService.title}】`}</h4>
                    <ul className={"itemContents"}>
                        <li>{suggestingService.detail}</li>
                    </ul>
                </div>
            ))}
        </>
    );
});

type Props = {
    disease: DiseaseDetail
    suggestingServiceRef: React.RefObject<HTMLHeadingElement>
};
